import { render, staticRenderFns } from "./FollowByBundle.vue?vue&type=template&id=4455f9a0&"
import script from "./FollowByBundle.vue?vue&type=script&lang=js&"
export * from "./FollowByBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports